export default __webpack_public_path__ + "static/media/AIPStatusPending.b4caa16c.png";